import VideoFormats from "@/components/home/VideoFormats";
import FinalCta from "@/components/home/FinalCta";
import RevealText from "@/components/shared/RevealText";
import { useLang } from "@/i18n/LanguageContext";
import SEO from "@/components/shared/SEO";

export default function VideoPage() {
  const { t } = useLang();
  return (
    <main data-testid="video-page" className="bg-black text-white">
      <SEO title={t.seo.video.title} description={t.seo.video.desc} />
      <section className="pt-40 md:pt-56 pb-16 border-b border-white/10">
        <div className="max-w-[1600px] mx-auto px-6 md:px-10">
          <p className="font-mono-eyebrow text-[var(--dp-accent)] mb-8">{t.video.eyebrow}</p>
          <RevealText
            lines={t.video.title.split("\n")}
            className="font-display text-5xl md:text-7xl lg:text-[104px] leading-[0.9] tracking-tighter font-medium"
          />
          <p className="mt-10 max-w-2xl text-neutral-300 text-lg md:text-xl leading-relaxed">{t.video.body}</p>
        </div>
      </section>
      <VideoFormats />
      <FinalCta />
    </main>
  );
}
